import { ApplicationState } from "..";
import { toErrorPayload } from "../../helpers/errorPayload";
import { SERVER_ERROR_MESSAGE, API_HOST_ERROR_MESSAGE } from "../../constants/errorMessages";

const method = "POST";
const headers = { "Content-Type": "application/json" };

export type PurchaseRequest = {
  crn: string;
  ssn: string;
  distance: number;
  paymentTypeCode?: string;
  paymentBankCode?: string;
  apiHost: string;
  brand: string;
  email: string;
  startDate: string;
  phoneNumber: string;
  coverageInternalCode: string;
  orderId: string;
  addonInternalCodes: string[];
  carHadAccidents: boolean | null;
  campaignId: string;
  deductibleCode: string;
  youngDriver: boolean | null;
  bankAccountOwnerName: string;
  bankAccountOwnerSSN: string;
  bankAccountNumber: string;
  bankAccountClearingNumber: string;
  bankNotAccountOwner: boolean;
  receiveInsuranceType: string;
  volvoCardOwner: boolean;
  webshopMode: number;
  quoteNumber: string;
  CalculationMethod: string;
  CarCode: string;
  disableBuying: boolean;
};

const Purchase = async (request: PurchaseRequest, state: ApplicationState, dispatch?: Function): Promise<ApplicationState> => {
  if (!request.apiHost) {
    if (dispatch)
      dispatch({
        type: "SET_SERVER_ERROR",
        payload: toErrorPayload({ message: API_HOST_ERROR_MESSAGE, header: SERVER_ERROR_MESSAGE }),
      });
    throw toErrorPayload({ message: API_HOST_ERROR_MESSAGE, header: SERVER_ERROR_MESSAGE });
  }

  const url = `${request.apiHost}/api2/${request.brand}/newwebshop/purchase`;

  // todo: replace;
  const data = {
    CarHadAccidents: request.carHadAccidents,
    CarRegistrationNumber: request.crn,
    DeductibleCode: request.deductibleCode,
    IsDriverUnder25: request.youngDriver,
    MileageCode: request.distance,
    PaymentMethodCode: request.paymentTypeCode,
    SelectedAddons: request.addonInternalCodes,
    SocialSecurityNumber: request.ssn,
    CampaignId: request.campaignId,
    Email: request.email,
    PhoneNumber: request.phoneNumber,
    StartDate: request.startDate,
    BankCode: request.paymentBankCode,
    WebshopMode: request.webshopMode,
    Brand: request.brand,
    AccountOwnerName: request.bankAccountOwnerName,
    AccountOwnerSSN: request.bankAccountOwnerSSN,
    BankAccountNumber: request.bankAccountNumber,
    ClearingNumber: request.bankAccountClearingNumber,
    NotAccountOwner: request.bankNotAccountOwner,
    CoverageInternalCode: request.coverageInternalCode,
    //VolvoCardAccountNumber: string,
    VolvoCardOwner: request.volvoCardOwner,
    QuoteNumber: request.quoteNumber,
    ProductId: null,
    ReceiveInsuranceType: request.receiveInsuranceType,
    DisableBuying: request.disableBuying,
    DealerPrice: false,
    OrderId: request.orderId,
  };

  const response = await fetch(`${url}`, {
    method,
    mode: "cors",
    headers,
    body: JSON.stringify(data),
  });

  const json = await response.json();

  if (response.status !== 200) {
    //uppercase Message is for compatibility with old API responses
    const message = (json && json.Message) ?? SERVER_ERROR_MESSAGE;
    if (dispatch)
      dispatch({
        type: "SET_SERVER_ERROR",
        payload: toErrorPayload({ message, header: SERVER_ERROR_MESSAGE }),
      });
    throw toErrorPayload({ message, header: SERVER_ERROR_MESSAGE });
  }

  sessionStorage.removeItem("store");
  return {
    ...state,
    signingService: {
      encryptedSigningId: json.EncryptedSigningId,
      signingService: json.SigningService,
      signingServiceUrl: json.SigningServiceUrl,
    },
  };
};

export default Purchase;
